document.addEventListener("DOMContentLoaded", () => {

    const tocList = document.querySelector(".bn-toc-list");
    const sections = [...document.querySelectorAll(".bn-privacy-content .privacy-item")];

    if (!tocList || !sections.length) return;

    tocList.innerHTML = "";

    const headerOffset = 80;

    // Active Class Function
    function setActive(index) {

        tocList.querySelectorAll("li").forEach(item => {
            item.classList.remove("active");
        });

        if (tocList.children[index]) {
            tocList.children[index].classList.add("active");
        }
    }

    // Generate TOC
    sections.forEach((section, index) => {

        section.id = `privacy-section-${index + 1}`;

        const heading = section.querySelector("h2");

        if (!heading) return;

        const li = document.createElement("li");

        if (index === 0) {
            li.classList.add("active");
        }

        li.innerHTML = `
            <button type="button">
                <span>${String(index + 1).padStart(2, "0")}.</span>
                ${heading.textContent}
            </button>
        `;

        li.querySelector("button").addEventListener("click", (e) => {

            e.preventDefault();

            setActive(index);

            const top =
                section.getBoundingClientRect().top +
                window.pageYOffset -
                headerOffset;

            window.scrollTo({
                top,
                behavior: "smooth"
            });

        });

        tocList.appendChild(li);

    });

    // Scroll Spy
    window.addEventListener("scroll", () => {

        let current = 0;

        sections.forEach((section, index) => {

            const top = section.offsetTop - headerOffset - 60;

            if (window.scrollY >= top) {
                current = index;
            }

        });

        setActive(current);

    });

});
